// eslint-disable-next-line @typescript-eslint/no-require-imports
require('@porscheofficial/cookie-consent-banner');
